import { render, staticRenderFns } from "./painter5.vue?vue&type=template&id=470bfa21&scoped=true&"
import script from "./painter5.vue?vue&type=script&lang=js&"
export * from "./painter5.vue?vue&type=script&lang=js&"
import style0 from "./painter5.vue?vue&type=style&index=0&id=470bfa21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bfa21",
  null
  
)

export default component.exports